import {forgetPasswordTypes} from "../../actions/AuthActions/AuthActionsTypes/ForgetPasswordActionsTypes";

/**
 * Forget password
 * @type {{success: boolean, loading: boolean}}
 */

const initForgetPasswordState = {
    loading: false,
    success: false,
};

const ForgetPasswordReducer = (state = initForgetPasswordState, action) => {
    switch (action.type) {
        case forgetPasswordTypes.FORGET_PASSWORD_REQUEST: {
            return Object.assign({}, state, {
                loading: true,
                success: false,
            });
        }

        case forgetPasswordTypes.FORGET_PASSWORD_SUCCESS: {
            return Object.assign({}, state, {
                loading: false,
                success: true,
            });
        }

        case forgetPasswordTypes.FORGET_PASSWORD_FAILURE: {
            return Object.assign({}, state, {
                loading: false,
                success: false,
            });
        }

        default: {
            return state;
        }
    }
};

export default ForgetPasswordReducer;
